// Lichte SVG-radar (spingrafiek) voor maturiteit per thema (0–5). Geen dependency.
// props: themes [{ section, avg, ... }]
export default function MaturityRadar({ themes = [], size = 260 }) {
  const pts = themes.filter(t => t.avg != null);
  const N = pts.length;
  if (N < 3) return null; // radar heeft minstens 3 assen nodig

  const cx = size / 2, cy = size / 2, R = size / 2 - 34, MAX = 5;
  const angle = (i) => (Math.PI * 2 * i) / N - Math.PI / 2;
  const at = (i, r) => [cx + Math.cos(angle(i)) * r, cy + Math.sin(angle(i)) * r];

  const rings = [1, 2, 3, 4, 5].map(v => pts.map((_, i) => at(i, R * v / MAX).join(',')).join(' '));
  const dataPoly = pts.map((p, i) => at(i, R * (p.avg / MAX)).join(',')).join(' ');

  return (
    <svg width={size} height={size} role="img" aria-label="Maturiteitsradar">
      {rings.map((r, idx) => <polygon key={idx} points={r} fill="none" stroke="#e2e8f0" strokeWidth="1" />)}
      {pts.map((_, i) => { const [x, y] = at(i, R); return <line key={i} x1={cx} y1={cy} x2={x} y2={y} stroke="#e2e8f0" strokeWidth="1" />; })}
      <polygon points={dataPoly} fill="rgba(37,99,235,0.22)" stroke="#2563eb" strokeWidth="2" />
      {pts.map((p, i) => { const [x, y] = at(i, R * (p.avg / MAX)); return <circle key={i} cx={x} cy={y} r="3" fill="#2563eb" />; })}
      {pts.map((p, i) => {
        const [x, y] = at(i, R + 16);
        return <text key={i} x={x} y={y} fontSize="11" fontWeight="600" textAnchor="middle" dominantBaseline="middle" fill="#475569">{p.section}</text>;
      })}
    </svg>
  );
}
